import { defineDepKeys, pickDeps } from "./depTools";

const GESTOR_DEPS_KEYS = defineDepKeys([
  "isFarmArchived",
  "T",
  "SyncStatusBar",
  "FarmCtx",
  "FarmDashboard",
  "farmDashboardDeps",
  "FarmEmoji",
  "fmtDate",
]);

function buildGestorPanelDeps(deps) {
  return pickDeps(deps, GESTOR_DEPS_KEYS);
}

export { GESTOR_DEPS_KEYS, buildGestorPanelDeps };
